import api from "../Service";
import { toastr } from "react-redux-toastr";

const baseController = "api/admin/dashboard/analytics";

const showError = (error) => {
  const message = error.response?.data?.message || error.message || "Please try again";
  toastr.error("Analytics", message);
};

const getAnalytics = async (path, params = {}) => {
  if (!navigator.onLine) {
    const error = new Error("No Internet Connection");
    showError(error);
    throw error;
  }

  try {
    const response = await api.get(`${baseController}/${path}`, { params });
    if (response.status === 200 && response.data?.status === true) {
      return response.data.data;
    }

    throw new Error(response.data?.message || "Could not retrieve analytics");
  } catch (error) {
    showError(error);
    throw error;
  }
};

const filenameFromHeader = (header, fallback) => {
  const match = header?.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i);
  return match ? decodeURIComponent(match[1]) : fallback;
};

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const getAnalyticsOverview = () => getAnalytics("overview");
export const getAnalyticsEngagement = ({ days = 30 } = {}) =>
  getAnalytics("engagement", { days });
export const getAnalyticsGenres = ({ limit = 20 } = {}) =>
  getAnalytics("genres", { limit });
export const getAnalyticsLeaderboards = ({ limit = 5 } = {}) =>
  getAnalytics("leaderboards", { limit });
export const getAnalyticsBooks = ({ page = 1, limit = 20, sort = "reads", search = "" } = {}) =>
  getAnalytics("books", { page, limit, sort, search });
export const getAnalyticsUsers = ({ page = 1, limit = 20, sort = "books", search = "" } = {}) =>
  getAnalytics("users", { page, limit, sort, search });
export const getAnalyticsSessions = ({ page = 1, limit = 20 } = {}) =>
  getAnalytics("sessions", { page, limit });

export const downloadAnalyticsCsv = async ({ section = "export", params = {}, filename }) => {
  if (!navigator.onLine) {
    const error = new Error("No Internet Connection");
    showError(error);
    throw error;
  }

  try {
    const isExportAll = section === "export";
    const response = await api.get(`${baseController}/${section}`, {
      params: isExportAll ? params : { ...params, format: "csv" },
      responseType: "blob",
    });
    const serverFilename = filenameFromHeader(
      response.headers["content-disposition"],
      filename || (isExportAll ? "AdminOverviewReport.csv" : `${section}.csv`)
    );
    downloadBlob(response.data, serverFilename);
    return true;
  } catch (error) {
    showError(error);
    throw error;
  }
};
